module.exports = __webpack_public_path__ + "1cb110614e9de459e7949afe2d68a25c.fbx";